<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary">
          <div class="box-header with-border">
            <!--  -->
            <div style="margin-top: 5px">
              <ul class="nav nav-tabs">
                <li class="active" @click="onClickTabSelect(1)">
                  <a data-toggle="tab" href="#electricAndWaterInvoice"
                    ><b>{{ $t("newsManagement.list") }}</b></a
                  >
                </li>
                <li @click="onClickTabSelect(2)">
                  <a data-toggle="tab" href="#managementFeeInvoice"
                    ><b>{{ $t("newsManagement.categoriesObj.list") }}</b></a
                  >
                </li>
              </ul>
              <div class="tab-content">
                <div
                  id="electricAndWaterInvoice"
                  class="tab-pane fade in active"
                >
                  <new-list ref="electricAndWaterInvoiceComponent" />
                </div>
                <div id="managementFeeInvoice" class="tab-pane fade">
                  <news-category-list ref="managementFeeInvoiceComponent" />
                </div>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </row>
    </div>
  </div>
</template>
<script>
import NewList from "./NewsList.vue";
import NewsCategoryList from "./NewsCategoryList.vue";
export default {
  components: {
    NewList,
    NewsCategoryList
  },
  data: () => ({
    tabList: [
      { value: 0, text: "newsManagement.list" },
      { value: 1, text: "project.all" }
    ],
    tabSelect: 1
  }),
  methods: {
    onClickTabSelect: function(value) {
      this.onTabSelect = value
      this.$router.replace({
        query: {
          onTabSelect: this.onTabSelect
        }
      })
    },
    activaTab(tab){
      $('.nav-tabs a[href="#' + tab + '"]').tab('show');
    },
    onShowTabSelect: function() {
      if (this.onTabSelect === 1) {
        this.activaTab('electricAndWaterInvoice')
      } else {
        this.activaTab('managementFeeInvoice')
      }
      this.onClickTabSelect(this.onTabSelect)
    }
  },
  mounted() {
    let onTabSelect = this.$route.query.onTabSelect
    if (onTabSelect != undefined) {
      this.onTabSelect = parseInt(onTabSelect)
      this.onShowTabSelect()
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsTabs.vue